import { render, staticRenderFns } from "./bookingConfig.vue?vue&type=template&id=89794994&scoped=true"
import script from "./bookingConfig.vue?vue&type=script&lang=ts"
export * from "./bookingConfig.vue?vue&type=script&lang=ts"
import style0 from "./bookingConfig.vue?vue&type=style&index=0&id=89794994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89794994",
  null
  
)

export default component.exports